<template>
    <div>
        <e-taglist>
            <e-tag v-for="(group, index) in groups" :key="index" type="primary">{{ group.name }}</e-tag>
        </e-taglist>
    </div>
</template>

<script>
export default {
    name: 'MetaGroups',
    props: {
        groups: {
            type: Array,
            required: true,
        },
    },
};
</script>
